export default function getDistance(
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
): any {
  const radLat1 = (lat1 * Math.PI) / 180.0
  const radLat2 = (lat2 * Math.PI) / 180.0
  const a = radLat1 - radLat2
  const b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0

  // Haversine 公式
  const s =
    2 *
    Math.asin(
      Math.sqrt(
        Math.pow(Math.sin(a / 2), 2) +
          Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)
      )
    )

  // 地球半径（单位：千米）
  const EARTH_RADIUS = 6378.137
  let distance = s * EARTH_RADIUS
  distance = Math.round(distance * 100) / 100
  return distance
}
